import '../css/style.scss'
import inView from 'in-view'
import Swiper from 'swiper/bundle'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  nav: 'view-nav',
}

class Script {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    inView('.inview').on('enter', (el) => {
      el.classList.add('is-view')
    })
    initMainSwiperIfNeeded()
    initArtistSwiperIfNeeded()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.pod = new Script()
})

window.addEventListener('resize', initMainSwiperIfNeeded)

let mainSwiper = null

function initMainSwiperIfNeeded() {
  const mainSwiperTarget = document.querySelector('[data-main-slider]')
  const isMobile = window.innerWidth <= 767

  if (mainSwiperTarget) {
    if (isMobile && !mainSwiper) {
      // Swiperの初期化
      mainSwiper = new Swiper('[data-main-slider]', {
        slidesPerView: 1.19,
        centeredSlides: true,
        spaceBetween: 16,
        loop: true,
        speed: 8000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        allowTouchMove: false,
        freeMode: true,
        freeModeMomentum: false,
        on: {
          init: () => {
            document
              .querySelectorAll('[data-main-slider] .swiper-wrapper')
              .forEach((el) => {
                el.style.transitionTimingFunction = 'linear'
              })
          },
        },
      })
    } else if (!isMobile && mainSwiper) {
      mainSwiper.destroy(true, true)
      mainSwiper = null
    }
  }
}

let artistSwiper01 = null
let artistSwiper02 = null

function initArtistSwiperIfNeeded() {
  const artistSwiperTarget01 = document.querySelector('[data-artist-slider01]')
  const artistSwiperTarget02 = document.querySelector('[data-artist-slider02]')


  if (artistSwiperTarget01) {
    artistSwiper01 = new Swiper('[data-artist-slider01]', {
      slidesPerView: 1.19,
      spaceBetween: 16,
      centeredSlides: true,
      loop: true,
      speed: 1000,
      autoplay: false,
      navigation: {
        nextEl: '[data-slider-artist01-next]',
        prevEl: '[data-slider-artist01-prev]',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.55,
          spaceBetween: 40,
          centeredSlides: true,
        },
      },
      on: {
        init: () => {
          document
            .querySelectorAll('[data-main-slider] .swiper-wrapper')
            .forEach((el) => {
              el.style.transitionTimingFunction = 'linear'
            })
        },
      }
    })
  }

  if (artistSwiperTarget02) {
    artistSwiper02 = new Swiper('[data-artist-slider02]', {
      slidesPerView: 1.19,
      spaceBetween: 16,
      centeredSlides: true,
      loop: true,
      speed: 1000,
      autoplay: false,
      navigation: {
        nextEl: '[data-slider-artist02-next]',
        prevEl: '[data-slider-artist02-prev]',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.55,
          spaceBetween: 40,
          centeredSlides: true,
        },
      },
      on: {
        init: () => {
          document
            .querySelectorAll('[data-main-slider] .swiper-wrapper')
            .forEach((el) => {
              el.style.transitionTimingFunction = 'linear'
            })
        },
      },
    })
  }
}